module.exports = __webpack_public_path__ + "img/members.f1721546.svg";